import { useContext } from 'react';

import { withAssetLoader } from '@mews/framework';

import { PlatformImageAssetLoaderContext } from './PlatformImageAssetLoaderContext';

export const withPlatformImageAssetLoader = withAssetLoader(PlatformImageAssetLoaderContext);

export const usePlatformImageGetAssetSrc = () => {
    const { assetLoader } = useContext(PlatformImageAssetLoaderContext);
    return assetLoader?.isInitialized === true ? assetLoader.getAssetSrc : undefined;
};
